import React, { Component } from 'react';
import { connect } from 'shalala';
import { Badge } from 'react-bootstrap';

import PacStatus from '../enum/PacStatus';
import { useStore } from '../../../store';
import Table from '../../../facturotopia/table/Table';
import ProviderCancellation from '../enum/ProviderCancellation';

class PacsList extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      columns: this.columns,
      selectedRowKeys: [],
    };
  }

  get columns() {
    return [
      {
        key: 'nombre',
        title: 'Pac',
        dataIndex: 'nombre',
      },
      {
        key: 'prioridad',
        title: 'Prioridad',
        dataIndex: 'prioridad',
        align: 'center',
      },
      {
        key: 'hits',
        title: 'Hits',
        dataIndex: 'hits',
        align: 'right',
      },
      {
        key: 'timbrados',
        title: 'Timbrados',
        dataIndex: 'timbrados',
        align: 'right',
      },
      {
        key: 'errores',
        title: 'Errores',
        dataIndex: 'errores',
        align: 'right',
      },
      {
        key: 'status',
        title: 'Status',
        dataIndex: 'status',
        render: renderStatus,
      },
      {
        key: 'cancellations',
        title: 'Cancelacion',
        dataIndex: 'cancellations',
        render: renderAllowedCancelStatus,
      },
    ];
  }

  async componentDidMount() {
    const { data } = this.props;

    if (data.length === 0) {
      this.paginate(1);
    }
  }

  paginate(meta) {
    const { filters = {} } = this.props;

    this.props.paginate({
      ...filters,
      ...meta,
    });
  }

  handleOnPageChange = (page) => {
    this.paginate({ page });
  };

  handleOnPageLimitChange = (limit) => {
    this.paginate({ limit, page: 1 });
  };

  handleRowSelectionChange = ({ selectedRowKeys, selectedRows }) => {
    this.setState(
      {
        selectedRowKeys: selectedRowKeys,
      },
      () => {
        const { onRowSelectionChange } = this.props;

        onRowSelectionChange && onRowSelectionChange({ selectedRowKeys, selectedRows });
      }
    );
  };

  getRowSelectionConfig = () => {
    return {
      type: 'checkbox',
      onChange: this.handleRowSelectionChange,
      getCheckboxProps: (record) => ({
        disabled: record.name === 'Disabled User', // Column uration not to be checked
        name: record.name,
      }),
    };
  };

  getPaginationConfig() {
    const { pagination } = this.props;

    return {
      metadata: pagination,
      onPageChange: this.handleOnPageChange,
      onPageLimitChange: this.handleOnPageLimitChange,
    };
  }

  render() {
    const { columns, selectedRowKeys } = this.state;
    const { data, busy } = this.props;
    const { onRowClick } = this.props;

    return (
      <Table
        loading={busy}
        columns={columns}
        rowKey={'id'}
        data={data}
        pagination={this.getPaginationConfig()}
        rowSelection={{
          selectedRowKeys: selectedRowKeys,
          ...this.getRowSelectionConfig(),
        }}
        onRowClick={onRowClick}
      ></Table>
    );
  }
}

const renderStatus = (item) => {
  let variant = 'warning';

  const status = PacStatus.search(item.status);

  if (status.isActive()) {
    variant = 'success';
  } else if (status.isInactive()) {
    variant = 'danger';
  }

  return <Badge variant={variant}>{status.getName()}</Badge>;
};

const renderAllowedCancelStatus = (item) => {
  let variant = 'warning';

  const cancelStatus = ProviderCancellation.search(item.cancellations);

  if (cancelStatus?.isEnabled()) {
    variant = 'success';
  } else if (cancelStatus?.isDisabled()) {
    variant = 'danger';
  }

  return <Badge variant={variant}>{cancelStatus?.getName()}</Badge>;
};

const mapState = (state) => {
  return state.admin.pacs.list;
};

const mapActions = (actions) => {
  return actions.admin.pacs.list;
};

export default connect(useStore, mapState, mapActions)(PacsList);
